import { Grid } from '@mui/material'
import React from 'react'
import BenefitsPanel from '../components/benefits-panel'
import CancelRightPanel from '../components/cancel-right-panel'
import StepHeader from '../components/step-header'
import StepPageContainer from '../components/step-page-container'

const ReviewPage = () => {
  return (
    <StepPageContainer>
      <Grid item xs={12}>
        <StepHeader />
      </Grid>
      <Grid item xs={12} sm={6}>
        <BenefitsPanel />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CancelRightPanel />
      </Grid>
    </StepPageContainer>
  )
}

export default ReviewPage
